export default "__VITE_ASSET__BLo8PJKT__"